// Extended page configurations – SEO, and buyer city pages for Kreis Mettmann

// ─── EXTENDED SEO INTENT PAGES ─────────────────────────────────────────────────
export const extendedSeoConfigs = {
  "doppelhaushaelfte-verkaufen-kreis-mettmann": {
    h1: "Doppelhaushälfte verkaufen im Kreis Mettmann",
    title: "Doppelhaushälfte verkaufen Kreis Mettmann | BRIMO Immobilien NRW",
    description:
      "Doppelhaushälfte im Kreis Mettmann verkaufen? BRIMO Immobilien NRW – kostenlose Bewertung, lokale Marktkenntnis, strukturierter Verkaufsprozess.",
    lead_type: "seller",
    formTitle: "Doppelhaushälfte bewerten",
    formCta: "Marktwert anfragen",
    showDistrict: true,
    showBudget: false,
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/42ada0df-a68a-464a-87b2-c661f7b68b9a/images/702f23570b9f392216c167b01660c60f4631c00079f694a83b5cbc41bea97254.png",
    intro:
      "Sie möchten Ihre Doppelhaushälfte im Kreis Mettmann verkaufen? Als lokaler Spezialist kennen wir die typischen Lagen, Preise und Käuferprofile für Doppelhaushälften in allen Städten des Kreises.",
    sections: [
      {
        title: "Doppelhaushälfte verkaufen im Kreis Mettmann – Was Sie wissen sollten",
        content:
          "Doppelhaushälften sind im Kreis Mettmann besonders bei Familien mit mittlerem Budget sehr gefragt. Sie bieten den Vorteil des Eigenheims bei reduziertem Grundstückspreis. Vor allem in familienfreundlichen Lagen wie Haan, Erkrath und Heiligenhaus erzielen Doppelhaushälften solide Verkaufspreise.",
      },
      {
        title: "Welchen Preis erzielt eine Doppelhaushälfte im Kreis Mettmann?",
        content:
          "Die Preise für Doppelhaushälften im Kreis Mettmann variieren je nach Stadt, Baujahr, Zustand und Ausstattung. Im Durchschnitt liegen die Verkaufspreise zwischen 280.000 und 550.000 Euro. In begehrten Lagen wie Langenfeld oder Monheim können auch höhere Preise erzielt werden.",
      },
      {
        title: "Besonderheiten beim Verkauf einer Doppelhaushälfte",
        content:
          "Beim Verkauf einer Doppelhaushälfte ist die Abgrenzung zum Nachbargebäude ein wichtiges Thema. Teilungserklärung, Grundbuchauszug und Grenzattest sind relevante Dokumente. Wir koordinieren alle erforderlichen Unterlagen und begleiten Sie durch den gesamten Verkaufsprozess.",
      },
    ],
  },

  "mehrfamilienhaus-verkaufen-kreis-mettmann": {
    h1: "Mehrfamilienhaus verkaufen im Kreis Mettmann",
    title: "Mehrfamilienhaus verkaufen Kreis Mettmann | BRIMO Immobilien NRW",
    description:
      "Mehrfamilienhaus im Kreis Mettmann verkaufen? BRIMO Immobilien NRW – fundierte Ertragswertbewertung, Investorennetzwerk, strukturierter Verkauf.",
    lead_type: "seller",
    formTitle: "Mehrfamilienhaus bewerten",
    formCta: "Ertragswert ermitteln",
    showDistrict: true,
    showBudget: false,
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/42ada0df-a68a-464a-87b2-c661f7b68b9a/images/7d6629f9672c53effdb91fd1640180f1cf61334c2fc622cac79c4293b5446b3a.png",
    intro:
      "Der Verkauf eines Mehrfamilienhauses erfordert spezifisches Fachwissen: Ertragswertermittlung, Mietrechtskenntnisse und Zugang zum Investorenmarkt. BRIMO Immobilien NRW verfügt über das notwendige Know-how.",
    sections: [
      {
        title: "Mehrfamilienhaus verkaufen – die richtige Strategie",
        content:
          "Mehrfamilienhäuser werden nach dem Ertragswertverfahren bewertet. Entscheidend sind Mieteinnahmen, Leerstand, Instandhaltungsrücklagen und Lage. Der Kreis Mettmann bietet als stabiler Mietmarkt attraktive Einstiegsmöglichkeiten für Kapitalanleger.",
      },
      {
        title: "Welche Unterlagen brauche ich beim Verkauf eines Mehrfamilienhauses?",
        content:
          "Notwendige Unterlagen sind: alle Mietverträge, Mieterliste mit Kaltmieten, Betriebskostenabrechnungen der letzten 3 Jahre, Grundbuchauszug, Baupläne, Energieausweis, Aufstellung aller Instandhaltungsmaßnahmen und laufenden Kosten.",
      },
      {
        title: "Investorenzielgruppe ansprechen",
        content:
          "Der Verkauf eines Mehrfamilienhauses richtet sich hauptsächlich an Kapitalanleger und institutionelle Investoren. Unser Netzwerk umfasst aktive Immobilieninvestoren aus dem Kreis Mettmann, Düsseldorf und der gesamten Region NRW.",
      },
    ],
  },

  "grundstueck-verkaufen-kreis-mettmann": {
    h1: "Grundstück verkaufen im Kreis Mettmann",
    title: "Grundstück verkaufen Kreis Mettmann | BRIMO Immobilien NRW",
    description:
      "Grundstück im Kreis Mettmann verkaufen? BRIMO Immobilien NRW – Bebauungsrechtsanalyse, Grundstücksbewertung, lokale Käufersuche.",
    lead_type: "seller",
    formTitle: "Grundstück bewerten",
    formCta: "Grundstückswert ermitteln",
    showDistrict: true,
    showBudget: false,
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/42ada0df-a68a-464a-87b2-c661f7b68b9a/images/d1ebd045c92e9b24408ad673dfd8f4ed7a5de0f6a93a81e784076fe8660d0de2.png",
    intro:
      "Möchten Sie Ihr Grundstück im Kreis Mettmann verkaufen? Der Wert eines Grundstücks hängt stark von Bebaubarkeit, Lage und Bodenrichtwert ab. BRIMO Immobilien NRW analysiert Ihr Grundstück professionell.",
    sections: [
      {
        title: "Was ist mein Grundstück im Kreis Mettmann wert?",
        content:
          "Der Wert eines Grundstücks wird primär nach Bodenrichtwert, Lage, Größe und Bebaubarkeit ermittelt. Im Kreis Mettmann liegen die Bodenrichtwerte je nach Stadt zwischen 150 und über 500 Euro pro Quadratmeter. Baureife Grundstücke in guten Lagen erzielen deutlich höhere Preise.",
      },
      {
        title: "Bebaubarkeit und Bebauungsplan",
        content:
          "Vor dem Verkauf eines Grundstücks ist die Prüfung des Bebauungsplans entscheidend. Wir klären für Sie, welche Bebauung zulässig ist, ob Erschließungskosten anfallen und welche Auflagen bestehen.",
      },
      {
        title: "Welche Grundstückstypen sind gefragt?",
        content:
          "Im Kreis Mettmann sind vor allem Baugrundstücke für Einfamilienhäuser in ruhigen Lagen und erschlossene Grundstücke für Mehrfamilienhäuser in städtischen Bereichen gefragt. Wir finden den richtigen Käufer für Ihr Grundstück.",
      },
    ],
  },
};

// ─── EXTENDED DISTRICT CONFIGS (no longer needed, all districts are in seoConfigs.districtConfigs) ────
export const extendedDistrictConfigs = {};

// ─── BUYER CITY CONFIGS ───────────────────────────────────────────────────
export const buyerDistrictConfigs = {
  hilden: {
    name: "Hilden",
    slug: "hilden",
    h1: "Immobilie kaufen in Hilden",
    title: "Immobilie kaufen Hilden | BRIMO Immobilien NRW",
    description:
      "Immobilie in Hilden kaufen? BRIMO Immobilien NRW – persönliche Beratung, Suchprofil & lokale Marktkenntnis.",
    about:
      "Hilden ist eine der beliebtesten Wohnstädte im Kreis Mettmann. Die hervorragende Anbindung an Düsseldorf per S-Bahn, die lebendige Innenstadt und die familienfreundliche Infrastruktur machen Hilden besonders attraktiv für Käufer.",
    marketInfo:
      "Der Kaufmarkt in Hilden bietet ein breites Spektrum: von Altbauwohnungen über moderne Neubauprojekte bis zu Einfamilienhäusern in ruhigen Wohngebieten. Die Preise sind stabil mit steigendem Trend.",
    priceRange: "ca. 2.500 – 3.800 €/m²",
    highlights: [
      "Hervorragende S-Bahn-Anbindung an Düsseldorf",
      "Lebendige Innenstadt mit Charme",
      "Vielfältiges Immobilienangebot",
      "Familienfreundliche Infrastruktur",
    ],
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/0b6954b7-7a0a-4ead-9726-e0037edf015a/images/54510c9c19ad0b9088471755150340814ac0ad8ac4432dd10c9bbe3378c4f55f.png",
  },

  ratingen: {
    name: "Ratingen",
    slug: "ratingen",
    h1: "Immobilie kaufen in Ratingen",
    title: "Immobilie kaufen Ratingen | BRIMO Immobilien NRW",
    description:
      "Immobilie kaufen in Ratingen? BRIMO Immobilien NRW – Ihr Makler mit Marktkenntnis. Vielseitiges Angebot in der größten Stadt im Kreis Mettmann.",
    about:
      "Ratingen ist die flächenmäßig größte Stadt im Kreis Mettmann und bietet ein breites Spektrum an Wohnmöglichkeiten. Von der historischen Altstadt bis zu modernen Neubaugebieten – Ratingen hat für jeden Lebensstil etwas zu bieten.",
    marketInfo:
      "Ratingen bietet eines der vielseitigsten Immobilienangebote im Kreis Mettmann. Die Nähe zu Düsseldorf und zum Flughafen macht die Stadt besonders attraktiv für Berufstätige und Familien.",
    priceRange: "ca. 2.500 – 4.200 €/m²",
    highlights: [
      "Vielseitiges Immobilienangebot",
      "Historische Altstadt",
      "Nähe zum Düsseldorfer Flughafen",
      "Breites Preisspektrum",
    ],
    heroImage:
      "https://images.unsplash.com/photo-1648670964980-16f9f4ba0c25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxSYXRpbmdlbiUyMEdlcm1hbnklMjBvbGQlMjB0b3duJTIwaGlzdG9yaWN8ZW58MHx8fHwxNzc2MDY1NTkxfDA&ixlib=rb-4.1.0&q=85",
  },

  langenfeld: {
    name: "Langenfeld",
    slug: "langenfeld",
    h1: "Immobilie kaufen in Langenfeld",
    title: "Immobilie kaufen Langenfeld | BRIMO Immobilien NRW",
    description:
      "Immobilie kaufen in Langenfeld? BRIMO Immobilien NRW – dynamische Stadt mit hoher Lebensqualität.",
    about:
      "Langenfeld ist eine dynamische Stadt im Süden des Kreises Mettmann mit hervorragender Autobahnanbindung und einer starken lokalen Wirtschaft. Die Stadt bietet modernen Wohnraum und eine ausgezeichnete Infrastruktur.",
    marketInfo:
      "Langenfeld verzeichnet eine stetig wachsende Nachfrage. Die Kombination aus Stadtnähe (Düsseldorf/Köln) und hoher Wohnqualität macht Langenfeld besonders für Familien und junge Berufstätige attraktiv.",
    priceRange: "ca. 2.800 – 4.200 €/m²",
    highlights: [
      "Hervorragende Autobahnanbindung",
      "Nähe zu Düsseldorf und Köln",
      "Moderne Infrastruktur",
      "Hohe Lebensqualität",
    ],
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/0b6954b7-7a0a-4ead-9726-e0037edf015a/images/30be55205d3fe9b7e1a5da24d8f352bff58cc12e4eada0d7ba65fc0894a4645a.png",
  },

  erkrath: {
    name: "Erkrath",
    slug: "erkrath",
    h1: "Immobilie kaufen in Erkrath",
    title: "Immobilie kaufen Erkrath | BRIMO Immobilien NRW",
    description:
      "Immobilie kaufen in Erkrath? BRIMO Immobilien NRW – naturnahes Wohnen an der Grenze zu Düsseldorf.",
    about:
      "Erkrath bietet die perfekte Kombination aus Natur und Stadtnähe. Das Neandertal als Naherholungsgebiet, die S-Bahn-Anbindung an Düsseldorf und die familienfreundliche Umgebung machen Erkrath zu einem begehrten Wohnort.",
    marketInfo:
      "Der Kaufmarkt in Erkrath profitiert von der Grenznähe zu Düsseldorf. Besonders Familien schätzen die grüne Umgebung bei gleichzeitiger Stadtnähe. Die Preise liegen im oberen Mittelfeld des Kreises.",
    priceRange: "ca. 2.200 – 3.800 €/m²",
    highlights: [
      "Neandertal als Naherholungsgebiet",
      "S-Bahn nach Düsseldorf",
      "Familienfreundliche Umgebung",
      "Attraktive Grünlage",
    ],
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/0b6954b7-7a0a-4ead-9726-e0037edf015a/images/0d927c17d167c162352d931a9b16999f3f2b92dfc5f47923927ef9817b111c06.png",
  },

  "monheim-am-rhein": {
    name: "Monheim am Rhein",
    slug: "monheim-am-rhein",
    h1: "Immobilie kaufen in Monheim am Rhein",
    title: "Immobilie kaufen Monheim am Rhein | BRIMO Immobilien NRW",
    description:
      "Immobilie kaufen in Monheim am Rhein? BRIMO Immobilien NRW – innovative Rheinstadt mit wachsender Attraktivität.",
    about:
      "Monheim am Rhein ist eine der innovativsten Städte in NRW. Die Lage am Rhein, niedrige Gewerbesteuern und eine zukunftsorientierte Stadtentwicklung machen Monheim zu einem aufstrebenden Wohnort mit hoher Lebensqualität.",
    marketInfo:
      "Der Kaufmarkt in Monheim am Rhein ist geprägt von steigender Nachfrage und modernem Neubau. Die innovative Stadtpolitik und die Rheinnähe treiben die Attraktivität und damit die Immobilienpreise.",
    priceRange: "ca. 2.800 – 4.500 €/m²",
    highlights: [
      "Innovative Stadtentwicklung",
      "Attraktive Rheinlage",
      "Moderne Neubauprojekte",
      "Wachsende Attraktivität",
    ],
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/0b6954b7-7a0a-4ead-9726-e0037edf015a/images/d237015c334c5589aef0f5f2028790a3e0e23d1e2c6755aea3680ff5844be990.png",
  },
};
